export const pp_championshipCaddieDefaultValuesUpdate = {
  championshipCaddie: {
    id: '',
    name: '',
    registrationStatus: '',

    antiCorruptionAndBettingPolicyAcceptance: false,
    caddieAddressSectionComplete: false,
    caddieContactSectionComplete: false,
    hasStartedPreRegistration: false,
    championshipAddressLine1: '',
    championshipAddressLine2: '',
    championshipCountyOrState: '',
    championshipEmail: '',
    championshipMobile: '',
    championshipPlayer: '',
    championshipPostcodeOrZipcode: '',
    championshipTownOrCity: '',
    emailChange: '',
    firstName: '',
    fridayTicket: '',
    lastName: '',
    mobileChange: '',
    saturdayTicket: '',
    sundayTicket: '',
    thursdayTicket: '',
    ticketingContactName: '',
    yardageBook: '',
  },
};
